"use client";

import FullScreen from "./FullScreen";
import { Brand, BrandConfiguration, Offer, Testimonial } from "@prisma/client";
import { useColorOverrides } from "components/cms/PageConfiguration/useColorOverrides";
import { trackEvent } from "./trackEvent";
import { useEffect } from "react";

const ClientSideModal = ({
  brand,
  internationalShippingOffer,
  offerIds,
  publishableStripeKey,
  testimonials,
  brandConfiguration,
}: {
  brand: Brand;
  internationalShippingOffer: Offer | null;
  offerIds: Array<string>;
  publishableStripeKey: string;
  testimonials: Array<Testimonial>;
  brandConfiguration: BrandConfiguration;
}) => {
  const [devModeColor, prodModeColor] = useColorOverrides(
    {},
    brandConfiguration
  );

  useEffect(() => {
    // this lets the injector script know that React is working and ready to receive users via the injected iFrame on LPs
    trackEvent("checkout-experience-initialized", {});
  }, []);

  return (
    <>
      {prodModeColor}
      <FullScreen
        internationalShippingOffer={internationalShippingOffer}
        offerIds={offerIds}
        brand={brand}
        publishableStripeKey={publishableStripeKey}
        testimonials={testimonials}
      />
    </>
  );
};

export default ClientSideModal;
